<template>

<div v-if="VM_link">

    <label>{{ $t('timetables.link') }}</label>
    <div class='link'>
        <a :href="link">{{ link }}</a>
    </div>

     <p-button type="default" size="sm" outline @click="copy()">
        <b-icon icon="clipboard-plus"/>
        <span>{{ $t('timetables.copy') }}</span>
    </p-button>

    <p-button type="default" size="sm" outline class="float-right" @click="open()">
        <b-icon icon="arrows-fullscreen"/>
        <span>{{ $t('timetables.open') }}</span>
    </p-button>
        
     <RequestInfo type="custom" :ok="copyDone" :okMsg="$t('timetables.clipboard')"/>

</div>
<div v-else>
    <fg-input v-model="title" :label="$t('timetables.title')" ></fg-input>
    
    <SelectList 
        :options="columnCountOptions" 
        :value="columnCount" 
        @select="onColumnCountSelect" 
        :searchable="false" 
        :clearable="false"
        :label="$t('timetables.cols')" />
 
    <SelectList 
        :options="extraColumnOptions" 
        :value="extraColumn" 
        @select="onExtraSelect" 
        :searchable="false" 
        :clearable="false"
        :label="$t('timetables.extra')" />
 
<!--
    <div class='link'>
        <a :href="link">{{ link }}</a>
    </div>
-->

    <t-button-group>
        <t-button type="open" icon='arrows-fullscreen' @click="open">{{ $t('timetables.open') }}</t-button> 
        <t-button type="copy" icon='clipboard-plus' @click="copy">{{ $t('timetables.copy') }}</t-button> 
    </t-button-group>

    <RequestInfo type="custom" :ok="copyDone" :okMsg="$t('timetables.clipboard')"/>

</div>

</template>


<script>
import settings from '@/store/system/settings'

export default {
    props: ['item'],
    data() {
        return {
            title: "",
            columnCount: "1",
            extraColumn: "-",
            columnCountOptions: [
                { id: '1', label: this.$t('timetables.col.1') },
                { id: '2', label: this.$t('timetables.col.2')  }
            ],
            extraColumnOptions: [
                { id: '-', label: this.$t('timetables.col.NA')  },
                { id: 'platform', label: this.$t('timetables.col.platform')  },
                { id: 'stop', label: this.$t('timetables.col.stop') },
                { id: 'stopname', label: this.$t('timetables.col.stopname') }
            ],
            copyDone: false,
            VM_link: null
        }
    },
    watch: {
        item(){
            this.copyDone = false;
        }
    },
    beforeCreate() {
        if (!this.$store.state.settings) {
            this.$store.registerModule("settings", settings);
        }
        this.$store.dispatch('settings/getSettingsList').finally(() => {  
            var settingsList = this.$store.state.settings.settingsList;
            if (!Array.isArray(settingsList)) {
                return;
            }
            var setting = settingsList.find(s => s.name == "VM_TIMETABLE_DISPLAY_URL");
            if(setting && setting.value)
                this.VM_link = setting.value;
        });
    },
    computed: {
        link(){
            if(this.VM_link){
                return this.VM_link.replace("[ID]", this.item.id);
            }
            else {
                var basePath = window.location.protocol + "//" 
                         + window.location.host 
                         + "/traveller/web?command=fullscreen"; 
            
                var id = "&id=" + this.item.id;
                var cols = "&cols=" + this.columnCount;
                var title = this.title ? "&title=" + this.title : "";
                var extra = this.extraColumn != "-" ? "&extracolumn=" + this.extraColumn : "";
            
                return basePath + id + cols + title + extra;
            }
        }
    },
    methods: {
        onColumnCountSelect(id){
            this.columnCount = id;
        },
        onExtraSelect(id){
            this.extraColumn = id;
        },
        copy(){
             var input = document.body.appendChild(document.createElement("input"));
            input.value = this.link;
            //input.focus();
            input.select();
            document.execCommand('copy');
            input.parentNode.removeChild(input);
            this.copyDone = true;
        },
        open(){
            window.open(this.link,'','fullscreen=yes,directories=no,location=no,menubar=no,resizable=no,scrollbars=no,status=no,titlebar=no,toolbar=no');

        }

    }

}

</script>

<style scoped lang="scss">
.link {
    margin: 2px 0 15px 0;
    padding: 20px 10px;
    border: 1px solid #ccc;
    font-size: 14px;
    text-align: center;
}

</style>
 